import { ThirdPartyAncillariesProvider } from '@fcom/common';

import { ExpediaLocaleData } from './interfaces';

export const MANAGE_BOOKING_FEATURE_KEY = 'manage-booking';

export const STATIC_OLD_MMB_POST_PARAMS = {
  SITE: 'FINRFINR',
  PAGE: 'BKGD',
};

const prefix = 'apis-update';
export const OPEN_TRAVEL_PREPARATIONS_NOTIFICATION = `${prefix}_open-travel-preparations-notification`;
export const CANCEL_APIS_UPDATE = `${prefix}-details_apis-cancel`;
export const FULL_APIS_UPDATE = `${prefix}-details-full_apis-success`;
export const PARTIAL_APIS_UPDATE = `${prefix}-details-partial_apis-success`;
export const ERROR_APIS_UPDATE = `${prefix}-details_apis-error`;
export const APIS_REQUIRED = `${prefix}_required`;
export const USER_OTHER_ADDRESS_APIS = `${prefix}-use-other-address_apis`;

export const GTM_BOOKING_WIDGET_ELEMENT_IDS = {
  [ThirdPartyAncillariesProvider.EXPEDIA_HOTEL]: 'booking-widget-tab-button_hotels',
  [ThirdPartyAncillariesProvider.CAR_TRAWLER_RENTAL]: 'booking-widget-tab-button_cartrawler-rental',
};

export const mapToGaString = {
  [ThirdPartyAncillariesProvider.CAR_TRAWLER_RENTAL]: 'third-party-box_cartrawler-rental',
  [ThirdPartyAncillariesProvider.CAR_TRAWLER_TRANSFER]: 'third-party-box_cartrawler-transfer',
  [ThirdPartyAncillariesProvider.EXPEDIA_HOTEL]: 'third-party-box_expedia-hotel',
};

export const mapToGaState = {
  [ThirdPartyAncillariesProvider.CAR_TRAWLER_RENTAL]: 'company: cartrawler',
  [ThirdPartyAncillariesProvider.CAR_TRAWLER_TRANSFER]: 'company: cartrawler',
  [ThirdPartyAncillariesProvider.EXPEDIA_HOTEL]: 'company: expedia',
};

export const carTrawlerSmartBlockConfig = {
  partnerName: 'finnair',
  CTProduct: 'widget',
};

export enum CarTrawlerClientID {
  MMB_TRIP_DETAILS_FIRST_24H = 608790,
  MMB_HOTELS_AND_CAR_RENTALS = 398065,
  MMB_ANCILLARY_CONFIRMATION_PAGE = 402825,
  MMB_CHECK_IN_CONFORMATION = 403743,
}

export const localeToLanguageAndCurrency: Record<string, ExpediaLocaleData> = {
  es_AR: { languageCode: 'es_AR', currencyCode: 'ARS' }, // Argentina
  en_AU: { languageCode: 'en_AU', currencyCode: 'AUD' }, // Australia
  nl_BE: { languageCode: 'nl_BE', currencyCode: 'EUR' }, // Belgium - Dutch
  fr_BE: { languageCode: 'fr_BE', currencyCode: 'EUR' }, // Belgium - French
  pt_BR: { languageCode: 'pt_BR', currencyCode: 'BRL' }, // Brazil
  en_CA: { languageCode: 'en_CA', currencyCode: 'CAD' }, // Canada - English
  fr_CA: { languageCode: 'fr_CA', currencyCode: 'CAD' }, // Canada - French
  zh_CN: { languageCode: 'zh_CN', currencyCode: 'CNY' }, // China
  da_DK: { languageCode: 'da_DK', currencyCode: 'DKK' }, // Denmark
  en_GB: { languageCode: 'en_GB', currencyCode: 'GBP' }, // England - English (Great Britian)
  en_UK: { languageCode: 'en_EN', currencyCode: 'GBP' }, // England - English (United Kingdom)
  fi_FI: { languageCode: 'fi_FI', currencyCode: 'EUR' }, // Finland
  en_FI: { languageCode: 'en_GB', currencyCode: 'EUR' }, // Finland - English
  fr_FR: { languageCode: 'fr_FR', currencyCode: 'EUR' }, // France
  de_DE: { languageCode: 'de_DE', currencyCode: 'EUR' }, // Germany
  en_DE: { languageCode: 'en_GB', currencyCode: 'EUR' }, // Germany - English
  zh_HK: { languageCode: 'zh_HK', currencyCode: 'HKD' }, // Hong Kong - Traditional Chinese
  en_HK: { languageCode: 'en_HK', currencyCode: 'HKD' }, // Hong Kong - English
  id_ID: { languageCode: 'id_ID', currencyCode: 'IDR' }, // Indonesia
  en_IE: { languageCode: 'en_IE', currencyCode: 'EUR' }, // Ireland
  it_IT: { languageCode: 'it_IT', currencyCode: 'EUR' }, // Italy
  ja_JP: { languageCode: 'ja_JP', currencyCode: 'JPY' }, // Japan
  en_MY: { languageCode: 'en_MY', currencyCode: 'MYR' }, // Malaysia - English
  ms_MY: { languageCode: 'ms_MY', currencyCode: 'MYR' }, // Malaysia - Malay
  es_MX: { languageCode: 'es_MX', currencyCode: 'MXN' }, // Mexico
  nl_NL: { languageCode: 'nl_NL', currencyCode: 'EUR' }, // The Netherlands
  nb_NO: { languageCode: 'nb_NO', currencyCode: 'NOK' }, // Norway
  en_PH: { languageCode: 'en_PH', currencyCode: 'PHP' }, // The Philippines
  en_SG: { languageCode: 'en_SG', currencyCode: 'SGD' }, // Singapore
  ko_KR: { languageCode: 'ko_KR', currencyCode: 'KRW' }, // South Korea
  es_ES: { languageCode: 'es_ES', currencyCode: 'EUR' }, // Spain - Spanish
  ca_ES: { languageCode: 'ca_ES', currencyCode: 'EUR' }, // Spain - Catalan
  sv_SE: { languageCode: 'sv_SE', currencyCode: 'SEK' }, // Sweden
  en_SE: { languageCode: 'en_GB', currencyCode: 'SEK' }, // Sweden - English
  de_CH: { languageCode: 'de_CH', currencyCode: 'CHF' }, // Switzerland - German
  fr_CH: { languageCode: 'fr_CH', currencyCode: 'CHF' }, // Switzerland - French
  zh_TH: { languageCode: 'zh_TH', currencyCode: 'TWD' }, // Taiwan
  th_TH: { languageCode: 'th_TH', currencyCode: 'THB' }, // Thailand
  en_US: { languageCode: 'en_US', currencyCode: 'USD' }, // English - United States
  vi_VN: { languageCode: 'vi_VN', currencyCode: 'VND' }, // Vietnam
};
